import { render, staticRenderFns } from "./DetallePedidoAnmac.vue?vue&type=template&id=04e4d3ed&"
import script from "./DetallePedidoAnmac.vue?vue&type=script&lang=js&"
export * from "./DetallePedidoAnmac.vue?vue&type=script&lang=js&"
import style0 from "./DetallePedidoAnmac.vue?vue&type=style&index=0&id=04e4d3ed&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports